import React, {useState, useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import AdminChatroom from './AdminChatroom'
import AdminMessages from './AdminMessages'
import Tab from '@material-ui/core/Tab'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles(theme => ({
  table: {
    marginBottom: theme.spacing(5)
  },
  tab: {
    backgroundColor: theme.palette.secondary.secondary,
    },
  tabSelect: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      textColor: theme.palette.secondary.main,
    },
  },
  paper: {
    'marginTop':theme.spacing(15),
  }
}))

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
      </div>
  );
}

export default function AdminMessagePage(){
  const [id, setId] = useState(0)
  const [value, setValue] = useState(0);
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setId(0)
  };

  useEffect(() => {
    if(id != 0){
      setValue(1)
    }
  }, [id,])

  return(
      <Grid item xs={12}>
        <Box className={classes.table}>
          <Tabs
            indicatorColor = 'primary'
            textColor = 'primary'
            variant = 'fullWidth'
            onChange = {handleChange}
            value = {value}
            className = {classes.tab}
            >
              <Tab label = 'All Messages' id = {0} className = {value!==0 ? classes.tabSelect : classes.tab}/>
              <Tab label = 'All Conversations' id = {1} className = {value!==1 ? classes.tabSelect : classes.tab}/>
            </Tabs>
            <TabPanel value={value} index={0}>
              <AdminMessages id = {id} setId = {setId}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AdminChatroom id = {id} setId = {id} />
            </TabPanel>
        </Box>
      </Grid>
  )
}
